import { media } from '@/styles/Qtheme';
import { COLORS } from '@app/constants';
import styled from 'styled-components';

export const DerivativesHeaderWrapper = styled.div`
  height: 100px;
  width: 100%;
  padding: 15px;
`;
export const CrossModalWrapper = styled.div`
  background-color: #242526;
  border-radius: 8px;
  display:flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  padding: 20px 16px;
`;
export const DerivativesHeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  padding: 7px;
  border-radius: 5px;
`;
export const CrossModalDescriptionBox = styled.div`
  background: #1a1c1b;
  border-radius: 8px;
  margin-top: 20px;
  padding: 12px;
  line-height: 1.5;

  @media ${media.mobile} {
    margin-top: 10px;
  }
`;
export const CrossModalLeverage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
`;
export const CrossTradeAmount = styled.div`
  background: #2a2c2e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 38px;
  padding: 4px 12px;
  border-radius: 6px;
`;

interface SliderBarProps extends React.InputHTMLAttributes<HTMLInputElement> {
  maxLeverage: string;
}
export const SliderBar = styled.input.attrs({
  type: 'range',
})<SliderBarProps>`
  -webkit-appearance: none;
  height: 4px;
  width: 100%;
  border-radius: 2px;
  background: ${({ value, maxLeverage }: any) =>
    `linear-gradient(to right, ${COLORS.primary} ${
      (value / maxLeverage) * 100
    }%, #2a2c2e ${(value / maxLeverage) * 100}%)`};
  outline: none;
  opacity: 1;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  margin-top: 20px;
  &:hover {
    opacity: 1;
  }
  &:focus {
    outline: none;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 14px;
    height: 14px;
    border: 2px solid ${COLORS.primary};
    border-radius: 50%;
    background: #242526;
    cursor: pointer;
  }
  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border: 2px solid ${COLORS.primary};
    border-radius: 50%;
    background: #242526;
    cursor: pointer;
  }
`;
export const SliderButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  user-select: none;
  margin-top: 12px;
`;

export const SliderButton = styled.button`
  background-color: transparent;
  border: none;
  font-size: 12px;
  font-weight: 400;
  color: #b3b5bd;
  cursor: pointer;
  padding: 0;
  letter-spacing: -0.36px;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;
